import { onActivated, onDeactivated, onScopeDispose } from 'vue';

/** One pending text-filter reload; other table actions can consume it immediately. */
export function useDebouncedFilterReload(reload, delay = 350) {
  let timer = null;
  let resumePending = false;
  const cancel = () => {
    if (timer != null) clearTimeout(timer);
    timer = null;
    resumePending = false;
  };
  const flush = () => {
    cancel();
    return reload();
  };
  const schedule = () => {
    cancel();
    timer = setTimeout(flush, delay);
  };
  onDeactivated(() => {
    const pending = timer != null;
    cancel();
    resumePending = pending;
  });
  onActivated(() => {
    if (resumePending) schedule();
  });
  onScopeDispose(cancel);
  return { schedule, flush, cancel };
}
